import React from 'react';
import { useOfferContext } from '../../../context';
import { Thumbnails } from '../../../components/Thumbnails';

export function ThumbnailsContainer() {
  const { thumbnails, media } = useOfferContext();

  if (thumbnails === null) {
    return null;
  }

  return <Thumbnails media={thumbnails} hasMore={media.length > 4} />;
}
